import React from 'react';
import { useDispatch } from 'react-redux';
import { Form as FinalForm } from 'react-final-form';
import { Modal, Button } from 'semantic-ui-react';
import arrayMutators from 'final-form-arrays';
import { EDIT_SPRAY_EVENT_MODAL } from 'scenes/Spray/scenes/Diary/constants';
import { updateQueryString } from 'services/router/actions';

import SummaryPage from '../SummaryPage';
import UncompleteSprayEventButton from '../../../../../UncompleteSprayEventButton';

interface Props {
    initialValues: Record<string, any>;
}

export default function ReadOnlySummary(props: Props): React.ReactElement {
    const { initialValues } = props;

    const dispatch = useDispatch();

    return (
        <React.Fragment>
            <Modal.Header>Completed Spray Event</Modal.Header>
            <Modal.Content>
                <section className="spray-event-modal || constrain-width">
                    <FinalForm
                        initialValues={initialValues}
                        onSubmit={(): void => {}}
                        mutators={{ ...arrayMutators }}
                    >
                        {(): React.ReactElement => <SummaryPage readOnly />}
                    </FinalForm>
                    <div className="footer-buttons || buttons">
                        <Button
                            type="button"
                            onClick={(): void => {
                                dispatch(
                                    updateQueryString({
                                        [EDIT_SPRAY_EVENT_MODAL]: undefined,
                                        sprayEventUuid: undefined
                                    })
                                );
                            }}
                            basic
                            primary
                        >
                            Close
                        </Button>
                        <UncompleteSprayEventButton />
                    </div>
                </section>
            </Modal.Content>
        </React.Fragment>
    );
}
